/**
 * Complete subcategories map — ALL main categories covered.
 * Each subcategory has a UNIQUE key for backend filtering.
 */
const SUBCATEGORIES = {
  // 1. Electronics & Accessories
  electronics_accessories: [
    { key: 'mobile_accessories', name_en: 'Mobile Phones', name_ar: 'الهواتف المحمولة' },
    { key: 'laptops_accessories', name_en: 'Laptops & Computers', name_ar: 'لابتوبات وكمبيوتر' },
    { key: 'electronics', name_en: 'TVs & Audio', name_ar: 'تلفزيونات وصوتيات' },
    { key: 'home_appliances', name_en: 'Home Appliances', name_ar: 'أجهزة منزلية' },
    { key: 'games_toys', name_en: 'Games & Consoles', name_ar: 'ألعاب وأجهزة' },
  ],

  // 2. Vehicles & Motorbikes
  vehicles_motorbikes: [
    { key: 'cars', name_en: 'Cars', name_ar: 'سيارات' },
    { key: 'motorcycles', name_en: 'Motorcycles & Scooters', name_ar: 'دراجات نارية' },
    { key: 'auto_parts', name_en: 'Auto Parts', name_ar: 'قطع غيار' },
    { key: 'heavy_vehicles', name_en: 'Trucks & Commercial', name_ar: 'شاحنات وتجاري' },
  ],

  // 3. Real Estate
  real_estate: [
    { key: 're_apartments', name_en: 'Apartments', name_ar: 'شقق' },
    { key: 're_houses', name_en: 'Houses', name_ar: 'منازل' },
    { key: 're_land', name_en: 'Land & Plots', name_ar: 'أراضي' },
    { key: 're_commercial', name_en: 'Commercial', name_ar: 'تجاري' },
  ],

  // 4. Jobs
  jobs: [
    { key: 'jobs_fulltime', name_en: 'Full-time', name_ar: 'دوام كامل' },
    { key: 'jobs_parttime', name_en: 'Part-time', name_ar: 'دوام جزئي' },
    { key: 'jobs_remote', name_en: 'Remote', name_ar: 'عمل عن بعد' },
    { key: 'jobs_freelance', name_en: 'Freelance', name_ar: 'عمل حر' },
  ],

  // 5. Services
  services: [
    { key: 'svc_home', name_en: 'Home Services', name_ar: 'خدمات منزلية' },
    { key: 'svc_tech', name_en: 'IT & Tech', name_ar: 'تقنية ومعلومات' },
    { key: 'svc_delivery', name_en: 'Delivery', name_ar: 'توصيل' },
    { key: 'svc_education', name_en: 'Education', name_ar: 'تعليم' },
    { key: 'svc_professional', name_en: 'Professional & Business', name_ar: 'مهني وأعمال' },
    { key: 'svc_wellness', name_en: 'Personal & Wellness', name_ar: 'شخصي وعافية' },
    { key: 'svc_other', name_en: 'Other', name_ar: 'أخرى' },
  ],

  // 6. Furniture
  furniture: [
    { key: 'furn_living', name_en: 'Living Room', name_ar: 'غرفة المعيشة' },
    { key: 'furn_bedroom', name_en: 'Bedroom', name_ar: 'غرفة النوم' },
    { key: 'furn_office', name_en: 'Office', name_ar: 'مكتبي' },
    { key: 'furn_kitchen', name_en: 'Kitchen', name_ar: 'مطبخ' },
  ],

  // 7. Clothes & Shoes
  clothes_shoes: [
    { key: 'womens_fashion', name_en: "Women's", name_ar: 'نسائي' },
    { key: 'mens_fashion', name_en: "Men's", name_ar: 'رجالي' },
    { key: 'kids_fashion', name_en: 'Kids', name_ar: 'أطفال' },
    { key: 'footwear', name_en: 'Shoes', name_ar: 'أحذية' },
  ],

  // 8. Health & Fitness
  health_fitness: [
    { key: 'gym_equipment', name_en: 'Gym Equipment', name_ar: 'أجهزة رياضية' },
    { key: 'supplements', name_en: 'Supplements', name_ar: 'مكملات' },
    { key: 'medical_devices', name_en: 'Medical', name_ar: 'طبي' },
  ],

  // 9. Sports Equipment
  sports_equipment: [
    { key: 'sports_football', name_en: 'Football', name_ar: 'كرة قدم' },
    { key: 'sports_fitness', name_en: 'Fitness', name_ar: 'لياقة' },
    { key: 'sports_outdoor', name_en: 'Outdoor', name_ar: 'رحلات' },
  ],

  // 10. Women & Beauty (NEW)
  womens_beauty: [
    { key: 'beauty_makeup', name_en: 'Makeup', name_ar: 'مستحضرات التجميل' },
    { key: 'beauty_skincare', name_en: 'Skincare', name_ar: 'العناية بالبشرة' },
    { key: 'beauty_haircare', name_en: 'Haircare', name_ar: 'العناية بالشعر' },
    { key: 'beauty_perfumes', name_en: 'Perfumes', name_ar: 'عطور' },
    { key: 'beauty_tools', name_en: 'Beauty Tools', name_ar: 'أدوات تجميل' },
  ],

  // 11. Agriculture (NEW)
  agriculture: [
    { key: 'agri_seeds', name_en: 'Seeds', name_ar: 'بذور' },
    { key: 'agri_fertilizers', name_en: 'Fertilizers', name_ar: 'أسمدة' },
    { key: 'agri_equipment', name_en: 'Farming Equipment', name_ar: 'معدات زراعية' },
    { key: 'agri_feed', name_en: 'Animal Feed', name_ar: 'أعلاف حيوانية' },
    { key: 'agri_crops', name_en: 'Crops & Harvest', name_ar: 'محاصيل' },
  ],

  // 12. Food & Beverage (NEW)
  food_beverage: [
    { key: 'food_grains', name_en: 'Grains & Staples', name_ar: 'حبوب وأساسيات' },
    { key: 'food_canned', name_en: 'Canned Food', name_ar: 'أغذية معلبة' },
    { key: 'food_beverages', name_en: 'Beverages', name_ar: 'مشروبات' },
    { key: 'food_spices', name_en: 'Spices', name_ar: 'بهارات وتوابل' },
    { key: 'food_wholesale', name_en: 'Wholesale', name_ar: 'جملة' },
  ],

  // 13. Energy (NEW)
  energy: [
    { key: 'energy_solar', name_en: 'Solar Panels', name_ar: 'ألواح شمسية' },
    { key: 'energy_inverters', name_en: 'Inverters & Batteries', name_ar: 'محولات وبطاريات' },
    { key: 'energy_generators', name_en: 'Generators', name_ar: 'مولدات' },
    { key: 'energy_electrical', name_en: 'Electrical Supplies', name_ar: 'مستلزمات كهربائية' },
  ],

  // 14. Industrial Machinery (NEW)
  industrial_machinery: [
    { key: 'ind_manufacturing', name_en: 'Manufacturing', name_ar: 'تصنيع' },
    { key: 'ind_heavy', name_en: 'Heavy Machinery', name_ar: 'معدات ثقيلة' },
    { key: 'ind_packaging', name_en: 'Packaging', name_ar: 'تغليف' },
  ],

  // 15. Apparel & Accessories (NEW)
  apparel_accessories: [
    { key: 'app_bags', name_en: 'Bags & Purses', name_ar: 'حقائب' },
    { key: 'app_watches', name_en: 'Watches', name_ar: 'ساعات' },
    { key: 'app_sunglasses', name_en: 'Sunglasses', name_ar: 'نظارات شمسية' },
    { key: 'app_belts', name_en: 'Belts & Wallets', name_ar: 'أحزمة ومحافظ' },
  ],

  // 16. Jewellery (NEW)
  jewellery: [
    { key: 'jewel_gold', name_en: 'Gold', name_ar: 'ذهب' },
    { key: 'jewel_silver', name_en: 'Silver', name_ar: 'فضة' },
    { key: 'jewel_diamonds', name_en: 'Diamonds', name_ar: 'ألماس' },
    { key: 'jewel_costume', name_en: 'Costume Jewelry', name_ar: 'مجوهرات تقليدية' },
  ],

  // 17. Pets & Cattle (NEW)
  pets_cattle: [
    { key: 'pets_cattle_cows', name_en: 'Cattle & Cows', name_ar: 'أبقار' },
    { key: 'pets_sheep', name_en: 'Sheep & Goats', name_ar: 'أغنام وماعز' },
    { key: 'pets_poultry', name_en: 'Poultry', name_ar: 'دواجن' },
    { key: 'pets_cats_dogs', name_en: 'Cats & Dogs', name_ar: 'قطط وكلاب' },
  ],

  // 18. Equipment & Tools (NEW)
  equipment_tools: [
    { key: 'tools_power', name_en: 'Power Tools', name_ar: 'أدوات كهربائية' },
    { key: 'tools_hand', name_en: 'Hand Tools', name_ar: 'أدوات يدوية' },
    { key: 'tools_construction', name_en: 'Construction', name_ar: 'بناء وتشييد' },
  ],

  // 19. IT Equipment (NEW)
  it_equipment_software: [
    { key: 'it_servers', name_en: 'Servers & Networking', name_ar: 'خوادم وشبكات' },
    { key: 'it_printers', name_en: 'Printers & Scanners', name_ar: 'طابعات وماسحات' },
    { key: 'it_software', name_en: 'Software', name_ar: 'برمجيات' },
  ],

  // 20. Gifts & Crafts (NEW)
  gifts_crafts: [
    { key: 'gifts_handmade', name_en: 'Handmade', name_ar: 'مصنوع يدوياً' },
    { key: 'gifts_flowers', name_en: 'Flowers & Plants', name_ar: 'زهور ونباتات' },
    { key: 'gifts_occasion', name_en: 'Occasion Gifts', name_ar: 'هدايا مناسبات' },
  ],

  // 21. Beauty & Personal Care (maps to beauty_personal_care)
  beauty_personal_care: [
    { key: 'bpc_skincare', name_en: 'Skincare', name_ar: 'العناية بالبشرة' },
    { key: 'bpc_makeup', name_en: 'Makeup', name_ar: 'مكياج' },
    { key: 'bpc_perfumes', name_en: 'Perfumes', name_ar: 'عطور' },
    { key: 'bpc_hair', name_en: 'Hair Products', name_ar: 'منتجات الشعر' },
  ],
};

export function getSubcategoryKeys(parentKey) {
  const subs = SUBCATEGORIES[parentKey];
  if (!subs) return [];
  return subs.map(s => s.key);
}

export function isSubcategoryKey(key) {
  for (const subs of Object.values(SUBCATEGORIES)) {
    if (subs.some(s => s.key === key)) return true;
  }
  return false;
}

export function getParentCategory(subKey) {
  for (const [parentKey, subs] of Object.entries(SUBCATEGORIES)) {
    if (subs.some(s => s.key === subKey)) return parentKey;
  }
  return null;
}

export default SUBCATEGORIES;
